import React from 'react';
import { motion } from 'framer-motion';

const heading = { fontFamily: "'Outfit', sans-serif" };

// Combined team grid (leadership first, then advisers, then support/admin).
const TEAM = [
  { img: '/brand/team/staff-7.webp', name: 'Michael', title: 'Co-founder & CEO, The Hereford Group' },
  { img: '/brand/team/staff-8.webp', name: 'Pierre', title: 'Co-founder & Senior Financial Adviser' },
  { img: '/brand/team/staff-9.webp', name: 'Emile', title: 'Co-founder & Senior Financial Adviser' },
  { img: '/brand/team/staff-2.webp', name: 'Rick', title: 'Financial Adviser' },
  { img: '/brand/team/staff-1.webp', name: 'Shayne', title: 'Financial Adviser' },
  { img: '/brand/team/staff-4.webp', name: 'Declan', title: 'Financial Adviser' },
  { img: '/brand/team/staff-6.webp', name: 'Julia', title: 'Office Manageress & Admin Executive' },
  { img: '/brand/team/staff-5.webp', name: 'Alix', title: 'Admin & Servicing Assistant' },
  { img: '/brand/team/staff-3.webp', name: 'Abbigail', title: 'Admin & Servicing Assistant' },
];

export const TeamSection = ({ id = 'team' }) => (
  <section id={id} className="relative overflow-hidden py-24" style={{ backgroundColor: '#0A1F44' }}>
    <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" />
    <div className="absolute -bottom-24 left-0 w-[420px] h-[420px] rounded-full blur-3xl pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(192,151,92,0.10), transparent 70%)' }} />
    <div className="relative z-10 max-w-7xl mx-auto px-6">
      <div className="max-w-2xl mb-14">
        <div className="text-xs font-semibold tracking-[0.3em] uppercase mb-3" style={{ color: '#C0975C' }}>Our Team</div>
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={heading}>
          The people behind <span className="text-gradient-gold">Precision Wealth</span>
        </h2>
        <p className="text-[15px] leading-relaxed" style={{ color: '#94A9C9' }}>
          A dedicated team of advisers and support professionals committed to your long-term financial wellbeing.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-testid="team-grid">
        {TEAM.map((m, i) => (
          <motion.div
            key={m.name}
            data-testid="team-member-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="group"
          >
            <div className="relative rounded-2xl overflow-hidden border transition-transform duration-500 group-hover:-translate-y-1" style={{ borderColor: '#1D3D72' }}>
              <img
                src={m.img}
                alt={`${m.name}, ${m.title}`}
                loading="lazy"
                width={640}
                height={640}
                className="w-full aspect-square object-cover"
              />
            </div>
            <div className="mt-4">
              <h3 className="text-lg md:text-xl font-bold text-white" style={heading}>{m.name}</h3>
              <p className="text-sm mt-0.5" style={{ color: '#C0975C' }}>{m.title}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default TeamSection;
